import { render, staticRenderFns } from "./errordialog.vue?vue&type=template&id=631bfbde&"
import script from "../ts/errordialog.ts?vue&type=script&lang=ts&"
export * from "../ts/errordialog.ts?vue&type=script&lang=ts&"
import style0 from "../assets/css/errordialog.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports